// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchGridResultAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var withProps = require('recompose').withProps;
  var withHandlers = require('recompose').withHandlers;
  var ObjectStateConstants = require('logic/data/Izenda.ObjectStateConstants');
  var SubscriptionPopupDesigner = require('modules/Subscription/Izenda.SubscriptionPopupDesigner');
  var SubscriptionDetails = require('logic/models/Izenda.SubscriptionDetails');
  var constants = require('logic/data/Izenda.DashboardSchedulingConstants');
  var DashboardStore = require('logic/Izenda.DashboardStore');
  var ReportDesignerConstants = require('logic/data/Izenda.ReportDesignerConstants');
  const { curry, getOr, isNil, findIndex, map, get, filter } = require('lodash/fp');

  var SearchGridResultAction = compose(
    withProps(function() {
      return {
        dashboardStore: new DashboardStore()
      };
    }),
    withHandlers({
      openEditPopup: curry(openEditPopup),
      deleteSchedule: curry(deleteSchedule),
      deleteSelectedSchedules: function(props) {
        return function() {
          deleteSelectedSchedules(props);
        };
      },
      goToPage: curry(goToPage),
      setPageSize: curry(setPageSize),
      handleChangeSortDirs: curry(handleChangeSortDirs)
    })
  );

  /**
   * Open edit schedule popup
   * @param props
   * @param schedule
   * @returns {*}
   */
  function openEditPopup(props, schedule) {
    var dashboardStore = props.dashboardStore;
    var id = getOr(null, 'subscription.dashboardId', schedule);
    var dashboardDetail = null;
    if (!isNil(id)) {
      dashboardDetail = getOr(null, 'model.dashboardDetail', dashboardStore);
      dashboardStore.loadDashboard(id);
    }
    var store = props.store;
    schedule.subscription.updateDataForEditMode({
      emailTemplates: store.emailTemplates,
      state: ObjectStateConstants.UPDATE,
      isSubscription: schedule.subscription.isSubscription
    });

    return props
      .openPopup(SubscriptionPopupDesigner, {
        reportState: ReportDesignerConstants.REPORT_STATE.SAVED,
        dashboardDetail: dashboardDetail,
        data: schedule.subscription,
        onSave: store.saveSchedule,
        onCheckDuplicateInstanceName: props.data.checkDuplicateScheduleName,
        onValidateSubscription: store.validateSchedule
      })
      .then(function(subscription) {
        updateGridAfterUpdateData(props.data, schedule, subscription);
      });
  }

  /**
   * Update a grid update update schedule
   * @param data
   * @param schedule
   * @param subscription
   */
  function updateGridAfterUpdateData(data, schedule, subscription) {
    schedule.subscription = new SubscriptionDetails(subscription);
    var index = findIndex({ id: schedule.id }, data.schedules);
    index > -1 && (data.schedules[index] = schedule);
  }

  /**
   * Delete schedule
   * @param props
   * @param schedule
   */
  function deleteSchedule(props, schedule) {
    var loader = props.loader;
    props
      .confirmFn('Confirmation', {
        description: constants.MESSAGE.M01a
      })
      .then(function() {
        loader.startLoading();
        return props.store.deleteSchedules([schedule.id]);
      })
      .then(function() {
        // Update grid after delete a schedule
        props.data.deleteSchedule(schedule);
      })
      .finally(loader.endLoading.bind(loader));
  }

  /**
   * Delete selected schedules
   * @param {object} props
   */
  function deleteSelectedSchedules(props) {
    var loader = props.loader;
    var schedules = props.data.schedules;
    var getDeletedId = compose(map(get('id')), filter({ selected: true }));
    var deletedIds = getDeletedId(schedules);
    var isAllChecked = props.data.isAllChecked;
    props
      .confirmFn('Confirmation', {
        description: constants.MESSAGE.M01b
      })
      .then(function() {
        loader.startLoading();
        return props.store.deleteSchedules(deletedIds);
      })
      .then(function() {
        isAllChecked ? props.store.updateGridSchedules(props.data) : props.data.deleteSelectedSchedules();
      })
      .finally(loader.endLoading.bind(loader));
  }

  /**
   * Handle going to specific page
   * @param props
   * @param pageIndex
   */
  function goToPage(props, pageIndex) {
    var data = props.data;
    data.setPageIndex(pageIndex);
    props.store.updateGridSchedules(data);
  }

  /**
   * Set number row showed on grid, reload data
   * @param props
   * @param pageSize
   */
  function setPageSize(props, pageSize) {
    props.data.setPageSize(pageSize);
    props.store.updateGridSchedules(props.data);
  }

  /**
   * Change sort column, then reload data
   * @param {object} props
   * @param {string} key
   * @param {string} sortType
   */
  function handleChangeSortDirs(props, key, sortType) {
    var loader = props.loader;
    loader.startLoading();
    props.data.setColSortDirs(key, sortType);
    props.store.updateGridSchedules(props.data).finally(loader.endLoading.bind(loader));
  }

  module.exports = SearchGridResultAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Scheduling/Izenda.SearchGridResultAction.js